import '../style/blog.css'

import { Color } from '@tiptap/extension-color'
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import Image from '@tiptap/extension-image'
import { EditorProvider, useCurrentEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import React from 'react'
import Document from '@tiptap/extension-document'
import Placeholder from '@tiptap/extension-placeholder'
import {FaBold, FaCode, FaEye, FaHeading, FaImage, FaItalic, FaListOl, FaListUl, FaQuoteLeft, FaRulerHorizontal, FaStrikethrough, FaUnderline} from 'react-icons/fa'
import Underline from '@tiptap/extension-underline'
import { useNavigate } from 'react-router-dom'
import { Tooltip, Typography } from '@mui/material'

const MenuBar = ({setOpen, setContent}) => {
  const { editor } = useCurrentEditor()
  const navigate = useNavigate()

  if (!editor) {
    return null
  }

  const handlePreviewBlog = () => {
    setContent(editor.getHTML())
    setOpen(true)
  }

  const saveImageToFirebase = () =>{

  }

  const addImage = () => {
    const url = window.prompt('Enter the image URL')

    if (url) {
      editor.chain().focus().setImage({ src: url }).run()
    }
  }

  return (
    <div className='menu-bar'>
      <div>
      <Tooltip title="Make text bold">
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .toggleBold()
            .run()
        }
        className={editor.isActive('bold') ? 'is-active' : ''}
      >
        <FaBold/>
      </button>
      </Tooltip>
      <Tooltip title="Make text italic">
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .toggleItalic()
            .run()
        }
        className={editor.isActive('italic') ? 'is-active' : ''}
      >
        <FaItalic/>
      </button>
      </Tooltip>
      <Tooltip title="Make text underline">
      <button
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .toggleUnderline()
            .run()
        }
        className={editor.isActive('underline') ? 'is-active' : ''}
      >
        <FaUnderline/>
      </button>
      </Tooltip>
      <Tooltip title="Strikethrough a text">
      <button
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .toggleStrike()
            .run()
        }
        className={editor.isActive('strike') ? 'is-active' : ''}
      >
        <FaStrikethrough/>
      </button>
      </Tooltip>
      <Tooltip title="Add a code">
      <button
        onClick={() => editor.chain().focus().toggleCode().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .toggleCode()
            .run()
        }
        className={editor.isActive('code') ? 'is-active' : ''}
      >
        <FaCode/>
      </button>
      </Tooltip>
      <Tooltip title="Add a heading">
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
      >
        <FaHeading/>
      </button>
      </Tooltip>
      <Tooltip title="Add a sub-heading">
      <button
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
        className={editor.isActive('heading', { level: 4 }) ? 'is-active' : ''}
      >
        <strong>H4</strong>
      </button>
      </Tooltip>
      <Tooltip title="Add a bulleted list">
      <button
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={editor.isActive('bulletList') ? 'is-active' : ''}
      >
        <FaListUl/>
      </button>
      </Tooltip>
      <Tooltip title="Add a numbered list">
      <button
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={editor.isActive('orderedList') ? 'is-active' : ''}
      >
        <FaListOl/>
      </button>
      </Tooltip>
      <Tooltip title="Add a code block">
      <button
        onClick={() => editor.chain().focus().toggleCodeBlock().run()}
        className={editor.isActive('codeBlock') ? 'is-active' : ''}
      >
        <strong>{'{'} {'}'}</strong>
      </button>
      </Tooltip>
      <Tooltip title="Add a quote block">
      <button
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        className={editor.isActive('blockquote') ? 'is-active' : ''}
      >
        <FaQuoteLeft/>
      </button>
      </Tooltip>
      <Tooltip title="Add a break line">
      <button onClick={() => editor.chain().focus().setHorizontalRule().run()}>
        <FaRulerHorizontal/>
      </button>
      </Tooltip>
      <Tooltip title="Add an image">
      <button onClick={() => addImage()}>
        <FaImage/>
      </button>
      </Tooltip>
      </div>
        <Tooltip title="Publish">
          <button onClick={handlePreviewBlog} onMouseEnter={()=>console.log("publish")}>
          <div className='publish'>
            <div className='publish-text'>
              <Typography>
                Publish
              </Typography>
            </div>
            <div className='publish-icon'>
              <FaEye/>
            </div>
            </div>
          </button>
        </Tooltip>
    </div>
  )
}

const CustomDocument = Document.extend({
  content: 'heading block*',
})

const extensions = [
  CustomDocument,
  Placeholder.configure({
    placeholder: ({ node }) => {
      if (node.type.name === 'heading') {
        return 'What’s the title?'
      }

      return 'Can you add some further context?'
    },
  }),
  Color.configure({ types: [TextStyle.name, ListItem.name] }),
  TextStyle.configure({ types: [ListItem.name] }),
  StarterKit.configure({
    document: false,
    bulletList: {
      keepMarks: true,
      keepAttributes: false,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false
    },
  }),
  Image.configure({
    inline: true,
    allowBase64: true,
  }),
  Underline
]

const content = ``

export default function BlogContent({setOpen, setContent}){

  return (
    <div className='text-editor'>
      <h2>Write Blog</h2>
      <EditorProvider slotBefore={<MenuBar setOpen={setOpen} setContent={setContent}/>}
      extensions={extensions} content={content}></EditorProvider>
    </div>
  )
}